import React from 'react';  // eslint-disable-line

const CloseModal = () => {
    return (
        <svg width="30" height="28" viewBox="0 0 30 28" xmlns="http://www.w3.org/2000/svg">
            <title>Shape</title>
            <path d="M15 14l14 14-14-14L29 0 15 14zm0 0L1 28l14-14L1 0l14 14z" stroke="#FFF" fill="none" fillRule="evenodd" strokeLinecap="square" />
        </svg>
    );
};

export default CloseModal;
